import React from "react";

const RedDotBadge = ({ className = "" }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="8"
    height="8"
    viewBox="0 0 8 8"
    fill="none"
  >
    <path
      d="M3.99992 6.83333C5.74882 6.83333 7.16658 5.41557 7.16658 3.66667C7.16658 1.91777 5.74882 0.5 3.99992 0.5C2.25102 0.5 0.833252 1.91777 0.833252 3.66667C0.833252 5.41557 2.25102 6.83333 3.99992 6.83333Z"
      fill="#E03B24"
      stroke="#EDEDF4"
    />
  </svg>
);

export default RedDotBadge;
